import { Table as BootstrapTable } from "react-bootstrap";
import styled, { css } from "styled-components";
const variantRowStyles = css(({ theme }) => {
  const { table } = theme.colors;
  let styles = "";
  const tableVariant = table.variant;
  const tableVariantHover = table.variantHover;
  const variants = {
    active: {
      background: tableVariant.active,
      hover: tableVariantHover.active
    },
    success: {
      background: tableVariant.success,
      hover: tableVariantHover.success
    },
    info: {
      background: tableVariant.info,
      hover: tableVariantHover.info
    },
    warning: {
      background: tableVariant.warning,
      hover: tableVariantHover.warning
    },
    danger: {
      background: tableVariant.danger,
      hover: tableVariantHover.danger
    }
  };
  Object.keys(variants).forEach((variant) => {
    const { background, hover } = variants[variant];
    styles += `
      &.table > thead > tr,
      &.table > tfoot > tr,
      &.table > tbody > tr {
        > td.${variant},
        > th.${variant},
        &.${variant} > td,
        &.${variant} > th {
          background-color: ${background};
        }
      }

      &.table-hover > tbody > tr {
        > td.${variant}:hover,
        > th.${variant}:hover,
        &.${variant}:hover > td,
        &:hover > .${variant},
        &.${variant}:hover > th {
          background-color: ${hover};
        }
      }
    `;
  });
  return css`
    ${styles}
  `;
});
const tableCss = css(
  ({ theme }) => css`
    &.table {
      > thead > tr,
      > tbody > tr,
      > tfoot > tr {
        > th,
        > td {
          border-top-color: ${theme.colors.table.row.divider};
          border-width: 1px;
        }
      }

      > thead > tr > th {
        background: ${theme.colors.table.head.background};
        white-space: nowrap;
        border-bottom-color: ${theme.colors.table.row.divider};
        border-width: 1px;
      }

      > tbody > tr {
        background-color: ${theme.colors.global.contentBackground};
        transition: background-color 150ms ease-in-out;
      }

      > tbody + tbody {
        border-top-color: ${theme.colors.table.row.divider};
        border-width: 1px;
      }

      .table {
        background-color: ${theme.colors.table.row.background};
      }
    }

    &.table-bordered {
      border-color: ${theme.colors.table.row.divider};

      > thead > tr,
      > tfoot > tr,
      > tbody > tr {
        > td,
        > th {
          border-color: ${theme.colors.table.row.divider};
        }
      }
    }

    &.table-striped > tbody > tr:nth-of-type(odd) {
      background-color: ${theme.colors.table.row.backgroundStriped};
    }

    &.table-hover > tbody > tr:hover {
      background-color: ${theme.colors.table.row.backgroundHover};
    }

    ${variantRowStyles}

    @media print {
      &.table > thead > tr > th {
        white-space: break-spaces;
        word-break: break-all;
      }
    }
  `
);
const Table = styled(BootstrapTable)`
  ${tableCss}
`;
export default Table;
export { tableCss };
